import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { firstValueFrom } from 'rxjs';
import { LoginFormComponent } from '../../components/login-form/login-form.component';
import { AuthStore } from '../../services/auth.store';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [CommonModule, ButtonModule, LoginFormComponent],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.css',
})
export class LoginPageComponent {
  readonly authStore = inject(AuthStore);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  readonly isRedirecting = signal(false);
  readonly isSubmitting = signal(false);
  readonly isLocalAuth = environment.auth.mode === 'local-auth';

  readonly returnUrl = computed(
    () => this.route.snapshot.queryParamMap.get('returnUrl') ?? '/',
  );

  async loginWithRedirect(): Promise<void> {
    this.isRedirecting.set(true);

    try {
      await this.authStore.loginWithRedirect(this.returnUrl());
    } catch {
      // Błąd jest już zapisany w AuthStore i pokazany w UI.
    } finally {
      this.isRedirecting.set(false);
    }
  }

  async loginLocal(credentials: { username: string; password: string }): Promise<void> {
    this.isSubmitting.set(true);

    try {
      await this.authStore.loginWithCredentials(credentials);
      const bootstrapped = await firstValueFrom(this.authStore.bootstrapSession(true));
      if (bootstrapped) {
        await this.router.navigateByUrl(this.returnUrl());
      }
    } catch {
      // Błąd jest już zapisany w AuthStore i pokazany w UI.
    } finally {
      this.isSubmitting.set(false);
    }
  }

  goBack(): void {
    this.router.navigateByUrl('/');
  }
}
